import React from "react";
import { Link, useLocation } from "react-router-dom";
import GlobalSidebarMenu from "../../default/header/globalSidebarMenu";
import { HashLink } from "react-router-hash-link";


const SidebarMenu = () => {
    const location = useLocation();
    const isActive = (hash) => location.hash === hash ? 'active-menu' : '';
    // Scroll with offset function for HashLink
    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -80; 
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    };
    return (
        <div className="card-menu-wrapper">
            <div className="sticky-area has-top-level-menu">
                <div className="top-level-menu">
                    <GlobalSidebarMenu sidebarTitle=" "/>
                </div>
                <ul>
                    <li><HashLink smooth scroll={scrollWithOffset}  className={isActive('#business-info')} to="#business-info">Basic Info</HashLink></li>
                    <li><HashLink smooth scroll={scrollWithOffset}  className={isActive('#category-section')} to="#category-section">Category</HashLink></li>
                    <li><HashLink smooth scroll={scrollWithOffset}  className={isActive('#service-section')} to="#service-section">Service</HashLink></li>
                    <li><HashLink smooth scroll={scrollWithOffset}  className={isActive('#address-section')} to="#address-section">Address</HashLink></li>
                </ul>
            </div>
        </div>
    );
}

export default SidebarMenu;
